/* global BigInt */
// Creates a request token matching DataLayer.GenerateTimestampToken on the server.
// Date.now() is UTC milliseconds, so the token is the same regardless of timezone.
export function generateTimestampToken() {
  const ticks = String(Date.now());

  // 3-digit checksum: sum of all digits of ticks, mod 1000, padded to 3 digits
  let sum = 0;
  for (const digit of ticks) sum += Number(digit);
  const checksum = String(sum % 1000).padStart(3, '0');

  // concatenate and convert to hex
  return BigInt(ticks + checksum).toString(16);
}
